module.exports = __webpack_public_path__ + "static/media/default.1b1b6491.svg";